module.exports = __webpack_public_path__ + "img/dang3.b344ce3a.png";